export enum LeadStatusEnum {
  toQualify = 'À qualifier',
  disabled = 'Sans suite'
}
